module.exports = __webpack_public_path__ + "static/img/2.f3f9650.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/7/1/eng/2.png
// module id = vpX4
// module chunks = 0